import { BaseModel } from '../../_base/crud';

export class Pharmacy extends BaseModel {
  id: number;
  name: string;
  phone: string;
  fax: string;
  email: string;
  city: string;
  state: string;
  zip: string;
  location_id: number;
  address_1: string;
  address_2: string;
  preferred_communication_method: 'EMAIL' | 'FAX';
  referral_info: string;
  pharmacy_id: string;
  dea: string;
  npi: string;
  pharmacy_group: any;
  note: string;
  is_active: boolean;

  urbanization;
  changeActiveStatus() {
    this.is_active = !this.is_active;
  }
}
